import { useRouter } from 'next/router';
import { useEffect } from 'react';

import { useTracerContext } from '../../../provider/TracerProvider';

export function useStartTrace({ guid }: { guid: string }) {
  const router = useRouter();

  // Tracing
  const { onStartTrace, onFinishTrace } = useTracerContext();
  useEffect(() => {
    console.log('START TRACE');
    onFinishTrace({ parentSpanName: 'regulation', isCancel: true });
    onStartTrace({ parentSpanName: 'regulation', guid, path: router.asPath });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
